import { useWeb3React } from '@web3-react/core';
import { Contract, ethers, Signer } from 'ethers';
import {
  ChangeEvent,
  MouseEvent,
  ReactElement,
  useEffect,
  useState,
  useRef
} from 'react';
import styled from 'styled-components';
import { Provider } from '../utils/provider';
import { Row, Col, Form, Button } from 'react-bootstrap'

//BUSD_LIVE
//import BUSD_Artifact from '../artifacts/BUSD_LIVE/BUSD_LIVE.json';
//import BUSD_Address from '../artifacts/BUSD_LIVE/BUSD_LIVE-address.json';

/*
//BUSD_TEST
import BUSD_Artifact from '../artifacts/contracts/ERC20GameToken.sol/ERC20GameToken.json';
import BUSD_Address from '../artifacts/contracts/BUSDToken.sol/BUSDToken-address.json';

//SAFUUTEST
import SAFUU_Artifact from '../artifacts/contracts/ERC20GameToken.sol/ERC20GameToken.json';
import SAFUU_Address from '../artifacts/contracts/SAFUUToken.sol/SAFUUToken-address.json';

//Contract TEST
import ERC721GameNFTArtifact from '../artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT.json';
import ERC721GameNFTAddress from '../artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT-address.json';

const projectId = '2IokpGwCpHQJeI02EcfiZfX8IPk';
const projectSecret = 'f3aecb0b3d2e8309f1531dab7edfed87';

*/

//BUSD LIVE
import BUSD_Artifact from '../live_artifacts/contracts/BUSDToken.sol/BUSDToken.json';
import BUSD_Address from '../live_artifacts/contracts/BUSDToken.sol/BUSDToken-address.json';

//SAFUU LIVE
import SAFUU_Artifact from '../live_artifacts/contracts/SAFUUToken.sol/SAFUUToken.json';
import SAFUU_Address from '../live_artifacts/contracts/SAFUUToken.sol/SAFUUToken-address.json';

//Contract LIVE
import ERC721GameNFTArtifact from '../live_artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT.json';
import ERC721GameNFTAddress from '../live_artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT-address.json';

const StyledDeployContractButton = styled.button`
  width: 240px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledGreetingDiv = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 135px 2.7fr 1fr;
  grid-gap: 10px;
  place-self: center;
  align-items: center;
`;

const StyledLabel = styled.label`
  font-weight: bold;
`;

const StyledInput = styled.input`
  padding: 0.4rem 0.6rem;
  line-height: 2fr;
`;

const StyledButton = styled.button`
  width: 150px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledAppDiv = styled.div`
  display: grid;
  grid-gap: 20px;
`;


export function ERC721GameNFTApp(): ReactElement {
  return (
    <StyledAppDiv>
      <NFTCreateContract />
    </StyledAppDiv>
  );
}

export function NFTCreateContract(): ReactElement {
  const context = useWeb3React<Provider>();
  const { library, active, account } = context;

  const [signer, setSigner] = useState<Signer>();
  const [NFTContract, setNFTContract] = useState<Contract>();
  const [NFTContractAddr, setNFTContractAddr] = useState<string>('');

  const [image, setImage] = useState('');
  const [price, setPrice] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const reffirstRef = useRef(null);

  const [nftTokenName, setTokenName] = useState<string>('');
  const [nftTokenSymbol, setTokenSymbol] = useState<string>('');
  const [nftTokenOwner, setTokenOwner] = useState<string>('');
  const [approveAmountInput, setApproveAmountInput] = useState<string>('');
  const [buyCFALPHAButton, setBuyCFALPHAButton] = useState<string>('APPROVE BUSD & MINT $CFALPHA NFT');
  const [buyCFALPHASafuuButton, setBuyCFALPHASafuuButton] = useState<string>('APPROVE SAFUU & MINT $CFALPHA NFT');

  const [totalBUSDRaised, setTotalBUSDRaised] = useState(0);
  const [totalSAFUURaised, setTotalSAFUURaised] = useState(0);
  const [busdBalance, setbusdBalance] = useState(0);
  const [safuuBalance, setsafuuBalance] = useState(0);
  const [totalNFTSupply, setTotalNFTSupply] = useState(0);

  const [transferBUSDAmountInput, setTransferBUSDAmountInput] = useState<string>('');
  const [transferSAFUUAmountInput, setTransferSAFUUAmountInput] = useState<string>('');
  
  useEffect((): void => {
    if (!library) {
      setSigner(undefined);
      return;
    }

    setSigner(library.getSigner());
  }, [library]);

  //Because state update is asynchronous we must listen for signer to be updated
  useEffect(() => {
    handleAttachContract();
  }, [signer]);

     //test for account change
     useEffect(() => {
      handleAttachContract();
    }, [account]);

  function handleAttachContract() {

    // only attach when a signer is defined
    if (!signer) {
      return;
    }


    async function attachNFTContract(signer: Signer): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        ERC721GameNFTArtifact.abi,
        ERC721GameNFTArtifact.bytecode,
        signer
      );

      try {
        //NOTE: ALWAYS PRE-DEPLOYED
        //const p2eGameContract = await P2EGame.deploy('Cosmic Force','CFX');
        //await p2eGameContract.deployed();

        const nftContract = await NFT.attach(ERC721GameNFTAddress.address);
       
        setNFTContract(nftContract);
 
       // window.alert(`P2EGame deployed to: ${p2eGameContract.address}`);

        const tokenName = await nftContract.name();
        const tokenSymbol = await nftContract.symbol();
        const tokenOwner = await nftContract.owner();
        const totalSupply = await nftContract.totalSupply();

        setNFTContractAddr(nftContract.address);
        setTokenName(tokenName);
        setTokenSymbol(tokenSymbol);
        setTokenOwner(tokenOwner);
        setTotalNFTSupply(Number(totalSupply));

        //Chech if BUSD approved and change to MINT buttin if so
        handleCheckApproveBUSD();
        handleCheckApproveSAFUU();

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    attachNFTContract(signer);
  }

  function handleCreateBUSDNFT(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    async function createNFT(signer: Signer): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        ERC721GameNFTArtifact.abi,
        ERC721GameNFTArtifact.bytecode,
        signer
      );

      const BUSD = new ethers.ContractFactory(
        BUSD_Artifact.abi,
        BUSD_Artifact.bytecode,
        signer
      );

      try {

        const BUSD_Contract = await BUSD.attach(BUSD_Address.address);

        const amountApproved = await BUSD_Contract.allowance(account, ERC721GameNFTAddress.address);
        const balanceBUSD = await BUSD_Contract.balanceOf(account);

        //If not enough allowence left
        if (Number(amountApproved) < (Number(ethers.utils.parseEther('100'))) ) {
          //Do Approve BUSD

        const listingPrice = ethers.utils.parseEther("30000");

        const setTxn = await BUSD_Contract.approve(ERC721GameNFTAddress.address,listingPrice); // = FFFFetc

        await setTxn.wait();

        setBuyCFALPHAButton('MINT $CFALPHA NFT WITH BUSD');

        window.alert(`BUSD Approve Success!`);

        }

        if(Number(balanceBUSD) < Number(ethers.utils.parseEther('100'))) {
          window.alert('Not enough BUSD balance');
          return;
        }

        const nftContract = await NFT.attach(ERC721GameNFTAddress.address);
        //const nftMarketplaceContract = await NFTMarketplace.attach(NFTMarketplaceAddress.address);
        const ticker = "BUSD";
        const tickerId = 0;
       // const result = await (ipfs as IPFSHTTPClient).add(JSON.stringify({image, price, name, description,ticker}));
       //const uri = `https://ipfs.io/ipfs/${result.path}`;

       // const uri = `{"image":"https://ipfs.io/ipfs/QmZ364K1f2jmiFdseKRfZeECPBJip8U7ST68Hk6ekphZY1","price":"100","name":"Cosmic Force Alpha Cadet","description":"Cosmic Force Alpha Cadet NFT","ticker":"BUSD"}`;

        const uri = "https://ipfs.io/ipfs/QmYwFL6A1CWTn3UmcRcfsnaXT17a4LPZzAZRmNQwWnNUHw";
        // mint nft 
        const result2 = await(await nftContract.mint(uri,tickerId)).wait();
        // get tokenId of new nft 
        //const id = await nftContract.tokenCount();

        const totalSupply = await nftContract.totalSupply();
        setTotalNFTSupply(Number(totalSupply));


        setBuyCFALPHAButton('MINT $CFALPHA NFT WITH BUSD');
        handleCheckApproveBUSD();

        window.alert(`Created ALPHA #${totalSupply} NFT`);


      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    createNFT(signer);
  }

  function handleCreateSAFUUNFT(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    async function createNFT(signer: Signer): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        ERC721GameNFTArtifact.abi,
        ERC721GameNFTArtifact.bytecode,
        signer
      );

      const SAFUU = new ethers.ContractFactory(
        SAFUU_Artifact.abi,
        SAFUU_Artifact.bytecode,
        signer
      );

      try {

        const SAFUU_Contract = await SAFUU.attach(SAFUU_Address.address);

        const amountApproved = await SAFUU_Contract.allowance(account, ERC721GameNFTAddress.address);
        const balanceSAFUU = await SAFUU_Contract.balanceOf(account);

        //If not enough allowence left 100000000 = 1000 Safuu
        if (Number(amountApproved) < (Number('100000000')) ) {
          //Do Approve SAFUU

        const listingPrice =  "3000000000";

        const setTxn = await SAFUU_Contract.approve(ERC721GameNFTAddress.address,listingPrice);

        await setTxn.wait();

        setBuyCFALPHASafuuButton('MINT $CFALPHA NFT WITH SAFUU');

        window.alert(`SAFUU Approve Success!`);

        }

        //************* CHANGE WITH PRICE CHANGE = 500 */
        if(Number(balanceSAFUU) < Number("60000000")) {
          window.alert('Not enough SAFUU balance');
          return;
        }

        const nftContract = await NFT.attach(ERC721GameNFTAddress.address);
       
        const ticker = "SAFUU";
        const tickerId = 1;
        //const result = await (ipfs as IPFSHTTPClient).add(JSON.stringify({image, price, name, description,ticker}));
        //const uri = `https://ipfs.io/ipfs/${result.path}`;

        //const uri = `{"image":"https://ipfs.io/ipfs/QmZ364K1f2jmiFdseKRfZeECPBJip8U7ST68Hk6ekphZY1","price":"100","name":"Cosmic Force Alpha Cadet","description":"Cosmic Force Alpha Cadet NFT","ticker":"BUSD"}`;

        const uri = "https://ipfs.io/ipfs/QmYwFL6A1CWTn3UmcRcfsnaXT17a4LPZzAZRmNQwWnNUHw";
        // mint nft 
        await(await nftContract.mint(uri,tickerId)).wait();
        // get tokenId of new nft 
        //const id = await nftContract.tokenCount();

        const totalSupply = await nftContract.totalSupply();
        setTotalNFTSupply(Number(totalSupply));

        setBuyCFALPHASafuuButton('MINT $CFALPHA NFT WITH SAFUU');
        handleCheckApproveSAFUU();

        window.alert(`Created ALPHA #${totalSupply} NFT`);

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    createNFT(signer);
  }

  function handleCheckApproveBUSD(): void {
   
    // only attach when a signer is defined
    if (!signer) {
      return;
    }

  async function approveCheckBUSD(signer: Signer): Promise<void> {
      
      //   const BUSDLIVE = new ethers.ContractFactory(
      //     BUSD_LIVEArtifact.abi,
      //     BUSD_LIVEArtifact.bytecode,
      //     signer
      //   );
  
        const BUSD = new ethers.ContractFactory(
          BUSD_Artifact.abi,
          BUSD_Artifact.bytecode,
          signer
        );
  
        try {
  
          const BUSD_Contract = await BUSD.attach(BUSD_Address.address);
            
          const amountApproved = await BUSD_Contract.allowance(account,ERC721GameNFTAddress.address);
  
          const contractBalanceBUSD = await BUSD_Contract.balanceOf(ERC721GameNFTAddress.address);     
          const totalRaised = Number(ethers.utils.formatUnits(contractBalanceBUSD,18));
          setTotalBUSDRaised(Math.ceil(totalRaised));
          
    
          const walletNewBalanceBUSD = await BUSD_Contract.balanceOf(account);
          const newBalanceBUSD = Number(ethers.utils.formatUnits(walletNewBalanceBUSD,18));
          setbusdBalance(newBalanceBUSD);
  
          //If not enough allowence left
          if (Number(amountApproved) > 0) {
            setBuyCFALPHAButton('MINT $CFALPHA NFT WITH BUSD');
          } else {
            setBuyCFALPHAButton('APPROVE BUSD & MINT $CFALPHA NFT');
          }
          
        } catch (error: any) {
          window.alert(
            'Error!' + (error && error.message ? `\n\n${error.message}` : '')
          );
        }
      }
  
    approveCheckBUSD(signer);
  }

  function handleCheckApproveSAFUU(): void {
   
      // only attach when a signer is defined
      if (!signer) {
        return;
      }
  
      async function approveCheckSAFUU(signer: Signer): Promise<void> {
        
        //   const BUSDLIVE = new ethers.ContractFactory(
        //     BUSD_LIVEArtifact.abi,
        //     BUSD_LIVEArtifact.bytecode,
        //     signer
        //   );
    
          const SAFUU = new ethers.ContractFactory(
            SAFUU_Artifact.abi,
            SAFUU_Artifact.bytecode,
            signer
          );
    
          try {
    
            const SAFUU_Contract = await SAFUU.attach(SAFUU_Address.address);
              
            const amountApproved = await SAFUU_Contract.allowance(account,ERC721GameNFTAddress.address);
    
            const contractBalanceSAFUU = await SAFUU_Contract.balanceOf(ERC721GameNFTAddress.address);     
            const totalSafuuRaised = Number(ethers.utils.formatUnits(contractBalanceSAFUU,5));
            setTotalSAFUURaised(Math.ceil(totalSafuuRaised));
            
      
            const walletNewBalanceSAFUU = await SAFUU_Contract.balanceOf(account);
            const newBalanceSAFUU = Number(ethers.utils.formatUnits(walletNewBalanceSAFUU,5));
            setsafuuBalance(newBalanceSAFUU);
    
            //If not enough allowence left
            if (Number(amountApproved) > 0) {
              setBuyCFALPHASafuuButton('MINT $CFALPHA NFT WITH SAFUU');
            } else {
              setBuyCFALPHASafuuButton('APPROVE SAFUU & MINT $CFALPHA NFT');
            }
            
          } catch (error: any) {
            window.alert(
              'Error!' + (error && error.message ? `\n\n${error.message}` : '')
            );
          }
      }
    
    approveCheckSAFUU(signer);
  }
    
  return (
    <>
      
      <div className="container-fluid">
      <div className="row">
        <main role="main" className="col-lg-12 mx-auto" style={{ maxWidth: '1000px' }}>
          <div className="content mx-auto">
            <Row className="g-4">
            <h6 className="p-4 text-center">
            Contract: {NFTContractAddr}
            </h6>
            </Row>
            <Row className="g-4">
            <h1 className="text-center">
            ALPHA CADET NFT
            </h1>
            </Row>
            <Row className="g-4">
            <Col>
            </Col>
            <Col>
            <h4 className="text-center">
              Minted
            </h4>
            </Col>
            <Col>
            <h4 className="text-center">
              Max Supply
            </h4>
            </Col>
            <Col>
            </Col>
          </Row>
          <Row className="g-4">
            <Col>
            </Col>
            <Col>
            <h5 className="text-center">
              {totalNFTSupply}
            </h5>
            </Col>
            <Col>
            <h5 className="text-center">
              2,100
            </h5>
            </Col>
            <Col>
            </Col>
          </Row>
            <Row className="g-8">
            <Col>
            </Col>
            <Col className="text-center" style={{ minWidth: '350px' }}>
            <img  src='./images/ALPHA.png' className='img-fluid' alt='...' />
            </Col>
            <Col>
            </Col>
          </Row>
          <Row className="g-4">
            <h5 className="p-4 text-center">
              1 $CFALPHA NFT = 100 $BUSD
            </h5>
          </Row>
            <Row className="g-4">

            <Col>
              <div className="d-grid px-8">
                <Button onClick={handleCreateBUSDNFT} variant="primary" size="lg">
                  {buyCFALPHAButton}
                </Button>
              </div>
              </Col>
            </Row>
            <Row className="g-4">
            <h6 className="p-4 text-center">
            Owning the Alpha Cadet NFT grants you full Cadet access to Leaderboards and Rewards from the Cosmic Force Treasury allowing you to progress in the game. The Alpha Cadet NFT also represents additional digital assets including: Starfighter, Basic Avatar, Combat Suit, Planetary Kit, Outpost Pod all issued as individual extra NFTs plus 25% discount of ALL in-game digital NFT asset purchases FOREVER once we launch on the Cosmic Blockchain.
            </h6>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-6">
            <Col className=" text-center ">
            <img src='./images/Alpha_Suit_Cropped.png' className='img-fluid' alt='...' />
            </Col>
            </Row>
            <Row className="g-6">
            <Col className="p-4 text-center">
            <img src='./images/Bundle_info.png' className='img-fluid' alt='...' />
            </Col>
            </Row>
            <Row className="g-6">
            <img src='./images/Spaceship.png' className='img-fluid' alt='...' />
            </Row>
            <div>&nbsp;</div>
            <Row className="g-6">
            <img src='./images/Outpost_Pod_no_Border_2.png' className='img-fluid' alt='...' />
            </Row>
            <div>&nbsp;</div>
            <div>&nbsp;</div>
            <Row className="g-6">
            <img src='./images/Planetary_Kit_No_border.png' className='img-fluid' alt='...' />
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
              <div className="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/9MueIoJjF5Y?autoplay=1&rel=0&modestbranding=1" title="Cosmic Force intro video"  allowFullScreen></iframe>
              </div>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
              <div className="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/QorWCp85Ia0?autoplay=1&rel=0&modestbranding=1" title="Cosmic Force intro video"  allowFullScreen></iframe>
              </div>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
              <div className="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/e29CQo7WIHY?autoplay=1&rel=0&modestbranding=1" title="Cosmic Force intro video"  allowFullScreen></iframe>
              </div>
            </Row>
          </div>
        </main>
      </div>
    </div>
    </>
  );
}
